<template>
  <div class="bg-white text-background-academy px-2 md:px-4 py-2 rounded
  flex items-center w-full justify-between text-sm md:text-base">
    <span> {{ date }}</span>
    <span>{{ payment.student.name }} </span>
    <span class="font-bold bg-grey-academy-150 p-1 md:p-2 rounded">
      {{ formatter.format(payment.total_paid/100) }}</span>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';

export default {
  props: ['payment'],

  computed: {
    ...mapGetters({
      choosenTimezone: 'timezone/choosenTimezone',
    }),

    date() {
      return dayjs(this.dateUTC).tz(this.choosenTimezone).format('LL');
    },

    dateUTC() {
      return dayjs.tz(this.payment.created_at, 'UTC');
    },
  },
};
</script>
